<template>
 <div>
  <router-view />
</div>
</template>

<script>

export default {
  name: 'car',
  components: {
  }
}
</script>
<style lang="less" scoped>
</style>
